
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'3-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메인화면 관리 - 추천여행 배너 {{ $route.query.recommend_banner_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.recommend_banner_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='recommend_banner_title'>타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'recommend_banner_title'
                maxLength="50"
                placeholder = "타이틀을 입력해 주세요.(50자 이내)"
                v-model="formData.recommendBannerTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.recommendBannerTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='recommend_banner_link'>링크<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'recommend_banner_link'
                maxLength="200"
                placeholder = "링크를 입력해 주세요."
                v-model="formData.recommendBannerLink"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.recommendBannerLinkError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='recommend_banner_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="recommend_banner_status"
                v-model="formData.recommendBannerStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='recommend_banner_main_status'>메인 노출<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="recommend_banner_main_status"
                v-model="formData.recommendBannerMainStatus"
              >
                <option value='1'>노출</option>
                <option value='2'>미노출</option>
              </select>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">메인 노출 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1080 x 1080px</p>
                <label for='recommend_banner_main_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.recommend_banner_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'recommend_banner_main_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_SquareBanner">
                  <img
                    :src="formData.recommendBannerMainImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.recommendBannerMainImageURL"
                    alt="PC용 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.recommendBannerMainImageURLError}}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_recommend_banner_one,
  insert_recommend_banner,
  update_recommend_banner
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminRecommendBannerManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner
  },
  setup () {
    return {
      formData: ref({
        recommendBannerTitle: '',
        recommendBannerLink: '',
        recommendBannerStatus: 1,
        recommendBannerMainStatus: 2,
        recommendBannerMainImage: '',
        recommendBannerMainImageURL: ''
      }),
      errorData: ref({
        recommendBannerTitleError: '',
        recommendBannerLinkError: '',
        recommendBannerMainImageURLError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.recommendBannerMainImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.recommendBannerMainImageURL = reader.result
        }
      }
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.recommendBannerTitle === '') {
        this.errorData.recommendBannerTitleError = '타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.recommendBannerTitleError = ''
      }
      if (this.formData.recommendBannerLink === '') {
        this.errorData.recommendBannerLinkError = '링크를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.recommendBannerLinkError = ''
      }
      if (this.formData.recommendBannerMainImageURL === '') {
        this.errorData.recommendBannerMainImageURLError = '메인 노출 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.recommendBannerMainImageURLError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.recommend_banner_ID === undefined) {
          insert_recommend_banner(
            this.formData.recommendBannerTitle,
            this.formData.recommendBannerLink,
            this.formData.recommendBannerMainImage,
            this.formData.recommendBannerStatus,
            this.formData.recommendBannerMainStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminRecommendBannerManagement'
          })
        } else {
          update_recommend_banner(
            this.$route.query.recommend_banner_ID,
            this.formData.recommendBannerTitle,
            this.formData.recommendBannerLink,
            this.formData.recommendBannerMainImage,
            this.formData.recommendBannerStatus,
            this.formData.recommendBannerMainStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminRecommendBannerManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.recommend_banner_ID !== undefined) {
      get_recommend_banner_one(this.$route.query.recommend_banner_ID).then((result) => {
        this.formData.recommendBannerTitle = result[0].recommend_banner_title
        this.formData.recommendBannerLink = result[0].recommend_banner_link
        this.formData.recommendBannerStatus = result[0].recommend_banner_status
        this.formData.recommendBannerMainStatus = result[0].recommend_banner_main_status
        this.formData.recommendBannerMainImageURL = result[0].recommend_banner_main_image
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminRecommendBannerManagementAdd.vue